export default "__VITE_ASSET__cb89c706__"